import { createAction } from 'redux-actions'

import * as constants from './constants'

export const fetchGeolocation = createAction(constants.FETCH_GEOLOCATION)
export const fetchGeolocationPending = createAction(constants.FETCH_GEOLOCATION_PENDING)
export const fetchGeolocationSuccess = createAction(constants.FETCH_GEOLOCATION_SUCCESS)
export const fetchGeolocationFailure = createAction(constants.FETCH_GEOLOCATION_FAILURE)



// WEBPACK FOOTER //
// ./src/modules/geolocation/actions.js